const reducerData = {
    name: 'notification',
    notifications: 'notifications'
};

export default reducerData